import React from "react";
import { useWatch } from "react-hook-form";
import { Divider, Grid, List, ListItem } from "@mui/material";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { Link } from "react-router";
import Tooltip from "@mui/material/Tooltip";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import Button from "../../../components/CustomButtons/Button";
import Edit from "@mui/icons-material/Edit";

export default function ChildUsers() {
  const childUsers = useWatch({ name: "child_users" });

  return (
    <Card style={{ maxWidth: 900 }}>
      <CardBody style={{ padding: 16 }}>
        <List>
          <ListItem style={{ flexDirection: "column", fontWeight: 800 }}>
            <Grid alignItems={"center"} container>
              <Grid item xs={2}>
                <TranslationWrapper tDefault={"#"} tKey={"ChildUsers.id"} />
              </Grid>
              <Grid item xs={6}>
                <TranslationWrapper tDefault={"E-mail address"} tKey={"ChildUsers.email"} />
              </Grid>
              <Grid item xs={2}>
                <TranslationWrapper tDefault={"Profile"} tKey={"ChildUsers.profile"} />
              </Grid>
              <Grid />
            </Grid>
            <Divider style={{ width: "100%" }} />
          </ListItem>
          {childUsers?.map((childUser) => {
            return (
              <ListItem style={{ flexDirection: "column" }}>
                <Grid alignItems={"center"} container>
                  <Grid item xs={2}>
                    {childUser.id}
                  </Grid>
                  <Grid item xs={6}>
                    {childUser.email}
                  </Grid>
                  <Grid item xs={2}>
                    {childUser.profile?.name}
                  </Grid>
                  <Grid item xs={2}>
                    <Link to={`/manager/gebruikers/${childUser.id}/edit`}>
                      <Tooltip
                        classes={{}}
                        placement={"bottom"}
                        title={<TranslationWrapper tDefault={"Open user"} tKey={"global.jamezzTable.viewUser"} />}
                      >
                        <Button color={"success"} simple>
                          <Edit />
                        </Button>
                      </Tooltip>
                    </Link>
                  </Grid>
                </Grid>
                <Divider style={{ width: "100%" }} />
              </ListItem>
            );
          })}
        </List>
      </CardBody>
    </Card>
  );
}
